import { createAction, props } from "@ngrx/store";
import { venueData } from "../../interfaces/services-data";

export const __updateVenues = createAction(
    '[Venues] Update',
    props<venueData>(),
)

export const __clearVenues = createAction(
    '[Venues] Clear'
)